import { html } from 'lit';

export const DefaultIcon = html`
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3334_77372)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.71294 6.47927C2.9781 6.34125 3.27709 6.21883 3.59925 6.11144C4.18904 5.91485 4.88593 5.759 5.65385 5.65385C5.759 4.88593 5.91485 4.18904 6.11144 3.59925C6.21883 3.27709 6.34125 2.9781 6.47927 2.71294C4.66435 3.23402 3.23402 4.66435 2.71294 6.47927ZM8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5ZM8 2.5C7.94272 2.5 7.80858 2.53437 7.61422 2.781C7.42429 3.02199 7.23139 3.4017 7.06013 3.91547C6.90527 4.38004 6.77549 4.9317 6.67997 5.5472C7.10671 5.5162 7.5484 5.5 8 5.5C8.4516 5.5 8.89329 5.5162 9.32003 5.5472C9.22451 4.9317 9.09473 4.38004 8.93987 3.91547C8.76861 3.4017 8.57571 3.02199 8.38579 2.781C8.19142 2.53437 8.05728 2.5 8 2.5ZM10.3461 5.65385C10.241 4.88593 10.0852 4.18904 9.88856 3.59925C9.78117 3.27709 9.65875 2.9781 9.52073 2.71294C11.3357 3.23402 12.766 4.66435 13.2871 6.47927C13.0219 6.34125 12.7229 6.21883 12.4008 6.11144C11.811 5.91485 11.1141 5.759 10.3461 5.65385ZM9.44027 6.55973C8.98158 6.52087 8.49906 6.5 8 6.5C7.50094 6.5 7.01842 6.52087 6.55973 6.55973C6.52087 7.01842 6.5 7.50094 6.5 8C6.5 8.49906 6.52087 8.98158 6.55973 9.44027C7.01842 9.47913 7.50094 9.5 8 9.5C8.49906 9.5 8.98158 9.47913 9.44027 9.44027C9.47913 8.98158 9.5 8.49906 9.5 8C9.5 7.50094 9.47913 7.01842 9.44027 6.55973ZM10.4528 9.32002C10.4838 8.89329 10.5 8.4516 10.5 8C10.5 7.5484 10.4838 7.10671 10.4528 6.67998C11.0683 6.7755 11.62 6.90527 12.0845 7.06013C12.5983 7.23139 12.978 7.42429 13.219 7.61422C13.4656 7.80858 13.5 7.94272 13.5 8C13.5 8.05728 13.4656 8.19142 13.219 8.38579C12.978 8.57571 12.5983 8.76861 12.0845 8.93987C11.62 9.09473 11.0683 9.2245 10.4528 9.32002ZM9.32003 10.4528C8.89329 10.4838 8.4516 10.5 8 10.5C7.5484 10.5 7.10671 10.4838 6.67998 10.4528C6.7755 11.0683 6.90527 11.62 7.06013 12.0845C7.23139 12.5983 7.42429 12.978 7.61422 13.219C7.80858 13.4656 7.94272 13.5 8 13.5C8.05728 13.5 8.19142 13.4656 8.38579 13.219C8.57571 12.978 8.76861 12.5983 8.93987 12.0845C9.09473 11.62 9.22451 11.0683 9.32003 10.4528ZM9.52073 13.2871C9.65875 13.0219 9.78117 12.7229 9.88856 12.4008C10.0852 11.811 10.241 11.1141 10.3461 10.3461C11.1141 10.241 11.811 10.0852 12.4008 9.88856C12.7229 9.78117 13.0219 9.65875 13.2871 9.52073C12.766 11.3357 11.3357 12.766 9.52073 13.2871ZM6.47927 13.2871C4.66435 12.766 3.23402 11.3357 2.71294 9.52073C2.9781 9.65875 3.27709 9.78117 3.59925 9.88856C4.18904 10.0852 4.88593 10.241 5.65385 10.3461C5.759 11.1141 5.91485 11.811 6.11144 12.4008C6.21883 12.7229 6.34125 13.0219 6.47927 13.2871ZM5.5472 9.32003C4.9317 9.22451 4.38004 9.09473 3.91547 8.93987C3.4017 8.76861 3.02199 8.57571 2.781 8.38579C2.53437 8.19142 2.5 8.05728 2.5 8C2.5 7.94272 2.53437 7.80858 2.781 7.61422C3.02199 7.42429 3.4017 7.23139 3.91547 7.06013C4.38004 6.90527 4.9317 6.7755 5.5472 6.67998C5.5162 7.10671 5.5 7.5484 5.5 8C5.5 8.4516 5.5162 8.89329 5.5472 9.32003Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3334_77372">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const EdgelessIcon = html`
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3334_76304)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.33341 3.16667C3.68908 3.16667 3.16675 3.68901 3.16675 4.33334C3.16675 4.97767 3.68908 5.5 4.33341 5.5C4.97775 5.5 5.50008 4.97767 5.50008 4.33334C5.50008 3.68901 4.97775 3.16667 4.33341 3.16667ZM2.16675 4.33334C2.16675 3.13672 3.1368 2.16667 4.33341 2.16667C5.53003 2.16667 6.50008 3.13672 6.50008 4.33334C6.50008 5.52995 5.53003 6.5 4.33341 6.5C3.1368 6.5 2.16675 5.52995 2.16675 4.33334Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.33341 10.5C3.68908 10.5 3.16675 11.0223 3.16675 11.6667C3.16675 12.311 3.68908 12.8333 4.33341 12.8333C4.97775 12.8333 5.50008 12.311 5.50008 11.6667C5.50008 11.0223 4.97775 10.5 4.33341 10.5ZM2.16675 11.6667C2.16675 10.4701 3.1368 9.5 4.33341 9.5C5.53003 9.5 6.50008 10.4701 6.50008 11.6667C6.50008 12.8633 5.53003 13.8333 4.33341 13.8333C3.1368 13.8333 2.16675 12.8633 2.16675 11.6667Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.83341 4.33334C6.83341 4.0572 7.05727 3.83334 7.33341 3.83334H8.00008C8.54726 3.83334 9.08907 3.94111 9.59459 4.15051C10.1001 4.3599 10.5594 4.66682 10.9464 5.05373C11.3333 5.44064 11.6402 5.89997 11.8496 6.40549C12.059 6.91101 12.1667 7.45283 12.1667 8V8.66667C12.1667 8.94281 11.9429 9.16667 11.6667 9.16667C11.3906 9.16667 11.1667 8.94281 11.1667 8.66667V8C11.1667 7.58415 11.0848 7.17237 10.9257 6.78817C10.7666 6.40398 10.5333 6.05489 10.2393 5.76083C9.9452 5.46678 9.59611 5.23353 9.21191 5.07439C8.82772 4.91525 8.41593 4.83334 8.00008 4.83334H7.33341C7.05727 4.83334 6.83341 4.60948 6.83341 4.33334Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.50008 10.6667C9.50008 10.0223 10.0224 9.5 10.6667 9.5H12.6667C13.3111 9.5 13.8334 10.0223 13.8334 10.6667V12.6667C13.8334 13.311 13.3111 13.8333 12.6667 13.8333H10.6667C10.0224 13.8333 9.50008 13.311 9.50008 12.6667V10.6667ZM10.6667 10.5C10.5747 10.5 10.5001 10.5746 10.5001 10.6667V12.6667C10.5001 12.7587 10.5747 12.8333 10.6667 12.8333H12.6667C12.7588 12.8333 12.8334 12.7587 12.8334 12.6667V10.6667C12.8334 10.5746 12.7588 10.5 12.6667 10.5H10.6667Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.33341 6.83334C4.60956 6.83334 4.83341 7.0572 4.83341 7.33334L4.83341 8.66667C4.83341 8.94281 4.60956 9.16667 4.33341 9.16667C4.05727 9.16667 3.83341 8.94281 3.83341 8.66667L3.83341 7.33334C3.83341 7.0572 4.05727 6.83334 4.33341 6.83334Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3334_76304">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const PageIcon = html`<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_3334_79048)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="currentColor"
      d="M2.16675 3.99999C2.16675 2.98747 2.98756 2.16666 4.00008 2.16666H9.33342C9.60956 2.16666 9.83342 2.39051 9.83342 2.66666C9.83342 2.9428 9.60956 3.16666 9.33342 3.16666H4.00008C3.53984 3.16666 3.16675 3.53975 3.16675 3.99999V13.3333C3.16675 13.6095 2.94289 13.8333 2.66675 13.8333C2.39061 13.8333 2.16675 13.6095 2.16675 13.3333V3.99999Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="currentColor"
      d="M13.8334 12C13.8334 13.0125 13.0126 13.8333 12.0001 13.8333H6.66675C6.39061 13.8333 6.16675 13.6095 6.16675 13.3333C6.16675 13.0572 6.39061 12.8333 6.66675 12.8333L12.0001 12.8333C12.4603 12.8333 12.8334 12.4602 12.8334 12L12.8334 2.66666C12.8334 2.39051 13.0573 2.16666 13.3334 2.16666C13.6096 2.16666 13.8334 2.39051 13.8334 2.66666L13.8334 12Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="currentColor"
      d="M5.50008 5.99999C5.50008 5.35566 6.02242 4.83332 6.66675 4.83332H9.33342C9.97775 4.83332 10.5001 5.35566 10.5001 5.99999V7.33332C10.5001 7.97765 9.97775 8.49999 9.33342 8.49999H6.66675C6.02242 8.49999 5.50008 7.97765 5.50008 7.33332V5.99999ZM6.66675 5.83332C6.5747 5.83332 6.50008 5.90794 6.50008 5.99999V7.33332C6.50008 7.42537 6.5747 7.49999 6.66675 7.49999H9.33342C9.42546 7.49999 9.50008 7.42537 9.50008 7.33332V5.99999C9.50008 5.90794 9.42546 5.83332 9.33342 5.83332H6.66675Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="currentColor"
      d="M5.50008 10.6667C5.50008 10.3905 5.72394 10.1667 6.00008 10.1667H10.0001C10.2762 10.1667 10.5001 10.3905 10.5001 10.6667C10.5001 10.9428 10.2762 11.1667 10.0001 11.1667H6.00008C5.72394 11.1667 5.50008 10.9428 5.50008 10.6667Z"
    />
  </g>
  <defs>
    <clipPath id="clip0_3334_79048">
      <rect width="16" height="16" fill="white" />
    </clipPath>
  </defs>
</svg>`;

export const RefreshIcon = html`
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3409_77646)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.70834 12C4.70834 7.97292 7.97293 4.70833 12 4.70833C13.8671 4.70833 15.5717 5.41092 16.8613 6.56516L16.8633 6.56695L18.0417 7.63079V5.33333C18.0417 4.98815 18.3215 4.70833 18.6667 4.70833C19.0119 4.70833 19.2917 4.98815 19.2917 5.33333V9.03704C19.2917 9.38221 19.0119 9.66204 18.6667 9.66204H14.963C14.6178 9.66204 14.338 9.38221 14.338 9.03704C14.338 8.69186 14.6178 8.41204 14.963 8.41204H17.0417L16.0276 7.49658C16.0273 7.49628 16.027 7.49599 16.0266 7.49569C14.9575 6.53917 13.5473 5.95833 12 5.95833C8.66329 5.95833 5.95834 8.66328 5.95834 12C5.95834 15.3367 8.66329 18.0417 12 18.0417C14.8745 18.0417 17.2815 16.0336 17.892 13.3432C17.9684 13.0066 18.3032 12.7956 18.6398 12.872C18.9764 12.9484 19.1874 13.2832 19.111 13.6198C18.3741 16.8671 15.471 19.2917 12 19.2917C7.97293 19.2917 4.70834 16.0271 4.70834 12Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3409_77646">
        <rect width="20" height="20" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
`;

export const DeleteIcon = html`
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3409_77647)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.3166 3.87493C11.3513 3.87497 11.3864 3.875 11.422 3.875H12.578C12.6136 3.875 12.6487 3.87497 12.6834 3.87493C13.2704 3.87439 13.7306 3.87396 14.1375 4.03401C14.4945 4.17443 14.8106 4.40223 15.0567 4.69654C15.3372 5.032 15.4824 5.46866 15.6674 6.02568C15.6784 6.05861 15.6895 6.09197 15.7007 6.12575L15.7838 6.375H18.6667C19.0119 6.375 19.2917 6.65482 19.2917 7C19.2917 7.34518 19.0119 7.625 18.6667 7.625H17.625V15.5268C17.625 16.2041 17.625 16.7505 17.5889 17.1929C17.5517 17.6484 17.473 18.0485 17.2844 18.4187C16.9848 19.0067 16.5067 19.4848 15.9187 19.7844C15.5485 19.973 15.1484 20.0516 14.6929 20.0889C14.2505 20.125 13.7041 20.125 13.0268 20.125H10.9732C10.2959 20.125 9.74954 20.125 9.30712 20.0889C8.85159 20.0516 8.45147 19.973 8.08129 19.7844C7.49328 19.4848 7.01522 19.0067 6.71561 18.4187C6.527 18.0485 6.44836 17.6484 6.41115 17.1929C6.375 16.7505 6.375 16.2041 6.37501 15.5268L6.37501 7.625H5.33334C4.98817 7.625 4.70834 7.34518 4.70834 7C4.70834 6.65482 4.98817 6.375 5.33334 6.375H8.2162L8.29929 6.12575C8.31055 6.09197 8.32163 6.05861 8.33257 6.02568C8.51767 5.46866 8.66277 5.032 8.9433 4.69654C9.18942 4.40224 9.50548 4.17443 9.86251 4.03401C10.2695 3.87396 10.7296 3.87439 11.3166 3.87493ZM8.65226 7.625C8.66195 7.62522 8.67162 7.62522 8.68127 7.625H15.3188C15.3284 7.62522 15.3381 7.62522 15.3478 7.625H16.375V15.5C16.375 16.2104 16.3745 16.7056 16.343 17.0911C16.3121 17.4693 16.2545 17.6866 16.1706 17.8512C15.9909 18.204 15.704 18.4909 15.3512 18.6706C15.1866 18.7545 14.9693 18.8121 14.5911 18.843C14.2056 18.8745 13.7104 18.875 13 18.875H11C10.2896 18.875 9.79444 18.8745 9.40891 18.843C9.03068 18.8121 8.81338 18.7545 8.64878 18.6706C8.29597 18.4909 8.00914 18.204 7.82937 17.8512C7.74551 17.6866 7.6879 17.4693 7.657 17.0911C7.6255 16.7056 7.62501 16.2104 7.62501 15.5V7.625H8.65226ZM14.466 6.375H9.53401C9.73142 5.78788 9.8018 5.61848 9.9022 5.49843C10.0141 5.36465 10.1577 5.2611 10.32 5.19728C10.4771 5.1355 10.6776 5.125 11.422 5.125H12.578C13.3225 5.125 13.5229 5.1355 13.68 5.19728C13.8423 5.2611 13.986 5.36465 14.0978 5.49843C14.1982 5.61848 14.2686 5.78788 14.466 6.375ZM10.3333 9.70833C10.6785 9.70833 10.9583 9.98815 10.9583 10.3333V16.1667C10.9583 16.5118 10.6785 16.7917 10.3333 16.7917C9.98817 16.7917 9.70834 16.5118 9.70834 16.1667V10.3333C9.70834 9.98815 9.98817 9.70833 10.3333 9.70833ZM13.6667 9.70833C14.0119 9.70833 14.2917 9.98815 14.2917 10.3333V16.1667C14.2917 16.5118 14.0119 16.7917 13.6667 16.7917C13.3215 16.7917 13.0417 16.5118 13.0417 16.1667V10.3333C13.0417 9.98815 13.3215 9.70833 13.6667 9.70833Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3409_77647">
        <rect width="20" height="20" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
`;

export const EditIcon = html`
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3409_77641)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.245 6.43527L14.543 7.16176L16.8382 9.45697L17.5647 8.755C18.2018 8.11415 18.2006 7.07817 17.5612 6.43876C16.9218 5.79935 15.8859 5.79819 15.245 6.43527ZM15.9392 10.3257L13.6743 8.06082L7.13833 14.8251L6.2655 17.7345L9.17493 16.8617L15.9392 10.3257ZM14.3576 5.55488C15.4863 4.42615 17.3164 4.42615 18.4451 5.55488C19.5738 6.68361 19.5738 8.51364 18.4451 9.64238L18.4375 9.64996L9.93429 17.8661C9.86252 17.9355 9.77518 17.9866 9.67959 18.0153L5.51292 19.2653C5.29269 19.3314 5.05397 19.2712 4.89139 19.1086C4.7288 18.946 4.66862 18.7073 4.73469 18.4871L5.98469 14.3204C6.01337 14.2248 6.06452 14.1375 6.13387 14.0657L14.3576 5.55488Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3409_77641">
        <rect width="20" height="20" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
`;

export const LinkIcon = html`
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3409_77679)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.7019 5.83896C14.2094 4.33145 16.6535 4.33145 18.161 5.83896C19.6685 7.34646 19.6685 9.79061 18.161 11.2981L16.4453 13.0138C16.2012 13.2579 15.8055 13.2579 15.5614 13.0138C15.3173 12.7698 15.3173 12.374 15.5614 12.13L17.2771 10.4142C18.2965 9.39488 18.2965 7.74219 17.2771 6.72284C16.2578 5.70349 14.6051 5.70349 13.5857 6.72284L11.2981 9.01048C10.2788 10.0298 10.2788 11.6825 11.2981 12.7019C11.4581 12.8619 11.633 12.9963 11.818 13.1055C12.1152 13.281 12.2138 13.6643 12.0383 13.9615C11.8628 14.2587 11.4795 14.3573 11.1823 14.1818C10.9076 14.0196 10.6492 13.8207 10.4142 13.5858C8.90671 12.0782 8.90671 9.6341 10.4142 8.1266L12.7019 5.83896ZM11.9617 10.0385C12.1372 9.74129 12.5204 9.64265 12.8177 9.81819C13.0924 9.98043 13.3508 10.1793 13.5857 10.4142C15.0932 11.9217 15.0932 14.3659 13.5857 15.8734L11.2981 18.161C9.7906 19.6685 7.34645 19.6685 5.83894 18.161C4.33144 16.6535 4.33144 14.2094 5.83894 12.7019L7.55467 10.9861C7.79875 10.7421 8.19448 10.7421 8.43855 10.9861C8.68263 11.2302 8.68263 11.6259 8.43855 11.87L6.72283 13.5858C5.70348 14.6051 5.70348 16.2578 6.72283 17.2771C7.74218 18.2965 9.39487 18.2965 10.4142 17.2771L12.7019 14.9895C13.7212 13.9702 13.7212 12.3175 12.7019 11.2981C12.5418 11.1381 12.367 11.0037 12.182 10.8945C11.8848 10.719 11.7861 10.3357 11.9617 10.0385Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3409_77679">
        <rect width="20" height="20" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
`;

export const CopyIcon = html`
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3409_77644)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.308 4.70833H16.0254C16.4705 4.70832 16.842 4.70832 17.1456 4.73312C17.4621 4.75898 17.7594 4.81491 18.0404 4.95811C18.4716 5.17782 18.8222 5.5284 19.0419 5.9596C19.1851 6.24066 19.241 6.53787 19.2669 6.85444C19.2917 7.15797 19.2917 7.5295 19.2917 7.97462V12.692C19.2917 13.1372 19.2917 13.5087 19.2669 13.8122C19.241 14.1288 19.1851 14.426 19.0419 14.7071C18.8222 15.1383 18.4716 15.4888 18.0404 15.7086C17.7594 15.8518 17.4621 15.9077 17.1456 15.9336C16.842 15.9584 16.4705 15.9583 16.0254 15.9583H15.9583V16.0254C15.9584 16.4705 15.9584 16.842 15.9336 17.1456C15.9077 17.4621 15.8518 17.7593 15.7086 18.0404C15.4889 18.4716 15.1383 18.8222 14.7071 19.0419C14.426 19.1851 14.1288 19.241 13.8122 19.2669C13.5087 19.2917 13.1372 19.2917 12.6921 19.2917H7.97463C7.52951 19.2917 7.15798 19.2917 6.85445 19.2669C6.53788 19.241 6.24067 19.1851 5.95962 19.0419C5.52841 18.8222 5.17783 18.4716 4.95812 18.0404C4.81492 17.7593 4.75899 17.4621 4.73313 17.1456C4.70833 16.842 4.70833 16.4705 4.70834 16.0254V11.308C4.70833 10.8628 4.70833 10.4913 4.73313 10.1878C4.75899 9.8712 4.81492 9.57399 4.95812 9.29294C5.17783 8.86173 5.52841 8.51115 5.95962 8.29144C6.24067 8.14824 6.53788 8.09231 6.85445 8.06645C7.15798 8.04165 7.52952 8.04166 7.97465 8.04167L8.04168 8.04167L8.04168 7.97464C8.04167 7.52951 8.04166 7.15797 8.06646 6.85444C8.09233 6.53787 8.14825 6.24066 8.29145 5.9596C8.51116 5.5284 8.86174 5.17782 9.29295 4.95811C9.574 4.81491 9.87122 4.75898 10.1878 4.73312C10.4913 4.70832 10.8629 4.70832 11.308 4.70833ZM8.04168 9.29167H8.00001C7.52299 9.29167 7.20281 9.29215 6.95624 9.3123C6.71697 9.33185 6.60257 9.36675 6.5271 9.4052C6.3311 9.50507 6.17175 9.66442 6.07188 9.86043C6.03343 9.93589 5.99852 10.0503 5.97898 10.2896C5.95883 10.5361 5.95834 10.8563 5.95834 11.3333V16C5.95834 16.477 5.95883 16.7972 5.97898 17.0438C5.99852 17.283 6.03343 17.3974 6.07188 17.4729C6.17175 17.6689 6.3311 17.8283 6.5271 17.9281C6.60257 17.9666 6.71697 18.0015 6.95624 18.021C7.20281 18.0412 7.52299 18.0417 8.00001 18.0417H12.6667C13.1437 18.0417 13.4639 18.0412 13.7104 18.021C13.9497 18.0015 14.0641 17.9666 14.1396 17.9281C14.3356 17.8283 14.4949 17.6689 14.5948 17.4729C14.6333 17.3974 14.6682 17.283 14.6877 17.0438C14.7079 16.7972 14.7083 16.477 14.7083 16V15.9583H11.308C10.8628 15.9583 10.4913 15.9584 10.1878 15.9336C9.87122 15.9077 9.574 15.8518 9.29295 15.7086C8.86174 15.4888 8.51116 15.1383 8.29145 14.7071C8.14825 14.426 8.09233 14.1288 8.06646 13.8122C8.04166 13.5087 8.04167 13.1372 8.04168 12.692L8.04168 9.29167ZM11.3333 14.7083C10.8563 14.7083 10.5361 14.7078 10.2896 14.6877C10.0503 14.6682 9.93591 14.6333 9.86044 14.5948C9.66444 14.4949 9.50508 14.3356 9.40521 14.1396C9.36676 14.0641 9.33186 13.9497 9.31231 13.7104C9.29216 13.4639 9.29168 13.1437 9.29168 12.6667V8C9.29168 7.52298 9.29216 7.2028 9.31231 6.95623C9.33186 6.71696 9.36676 6.60256 9.40521 6.52709C9.50508 6.33109 9.66444 6.17174 9.86044 6.07187C9.93591 6.03342 10.0503 5.99851 10.2896 5.97896C10.5361 5.95882 10.8563 5.95833 11.3333 5.95833H16C16.477 5.95833 16.7972 5.95882 17.0438 5.97896C17.2831 5.99851 17.3975 6.03342 17.4729 6.07187C17.6689 6.17174 17.8283 6.33109 17.9281 6.52709C17.9666 6.60256 18.0015 6.71696 18.021 6.95623C18.0412 7.2028 18.0417 7.52298 18.0417 8V12.6667C18.0417 13.1437 18.0412 13.4639 18.021 13.7104C18.0015 13.9497 17.9666 14.0641 17.9281 14.1396C17.8283 14.3356 17.6689 14.4949 17.4729 14.5948C17.3975 14.6333 17.2831 14.6682 17.0438 14.6877C16.7972 14.7078 16.477 14.7083 16 14.7083H11.3333Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3409_77644">
        <rect width="20" height="20" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
`;

export const CaptionIcon = html`
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3409_77683)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.70831 6.16666C4.70831 5.36125 5.36123 4.70833 6.16665 4.70833H9.49998C10.3054 4.70833 10.9583 5.36125 10.9583 6.16666V9.49999C10.9583 10.3054 10.3054 10.9583 9.49998 10.9583H6.16665C5.36123 10.9583 4.70831 10.3054 4.70831 9.49999V6.16666ZM6.16665 5.95833C6.05159 5.95833 5.95831 6.0516 5.95831 6.16666V9.49999C5.95831 9.61505 6.05159 9.70833 6.16665 9.70833H9.49998C9.61504 9.70833 9.70831 9.61505 9.70831 9.49999V6.16666C9.70831 6.0516 9.61504 5.95833 9.49998 5.95833H6.16665Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.70831 18.6667C4.70831 18.3215 4.98814 18.0417 5.33331 18.0417L15.3333 18.0417C15.6785 18.0417 15.9583 18.3215 15.9583 18.6667C15.9583 19.0118 15.6785 19.2917 15.3333 19.2917L5.33331 19.2917C4.98813 19.2917 4.70831 19.0118 4.70831 18.6667Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.70831 14.5C4.70831 14.1548 4.98814 13.875 5.33331 13.875L18.6666 13.875C19.0118 13.875 19.2916 14.1548 19.2916 14.5C19.2916 14.8452 19.0118 15.125 18.6666 15.125L5.33331 15.125C4.98813 15.125 4.70831 14.8452 4.70831 14.5Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3409_77683">
        <rect width="20" height="20" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
`;

export const DuplicateIcon = html`
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3409_77645)">
      <path
        d="M11.375 9.5C11.375 9.84518 11.6548 10.125 12 10.125H12.9911L8.22474 14.8914C7.98066 15.1355 7.98066 15.5312 8.22474 15.7753C8.46881 16.0194 8.86454 16.0194 9.10862 15.7753L13.875 11.0089V12C13.875 12.3452 14.1548 12.625 14.5 12.625C14.8452 12.625 15.125 12.3452 15.125 12V9.58333C15.125 9.56886 15.1246 9.5545 15.1237 9.54024C15.1348 9.36716 15.0742 9.19034 14.942 9.05806C14.8097 8.92578 14.6328 8.86519 14.4598 8.87629C14.4455 8.87543 14.4311 8.875 14.4167 8.875H12C11.6548 8.875 11.375 9.15482 11.375 9.5Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.0254 4.70833H11.308C10.8629 4.70832 10.4913 4.70832 10.1878 4.73312C9.87122 4.75898 9.574 4.81491 9.29295 4.95811C8.86174 5.17782 8.51116 5.5284 8.29145 5.9596C8.14825 6.24066 8.09233 6.53787 8.06646 6.85444C8.04166 7.15797 8.04167 7.5295 8.04168 7.97463L8.04168 8.04167L7.97465 8.04167C7.52953 8.04166 7.15798 8.04165 6.85445 8.06645C6.53788 8.09231 6.24067 8.14824 5.95962 8.29144C5.52841 8.51115 5.17783 8.86173 4.95812 9.29294C4.81492 9.57399 4.75899 9.8712 4.73313 10.1878C4.70833 10.4913 4.70834 10.8628 4.70834 11.308V16.0254C4.70834 16.4705 4.70833 16.842 4.73313 17.1456C4.75899 17.4621 4.81492 17.7593 4.95812 18.0404C5.17783 18.4716 5.52841 18.8222 5.95962 19.0419C6.24067 19.1851 6.53788 19.241 6.85445 19.2669C7.15798 19.2917 7.52951 19.2917 7.97463 19.2917H12.6921C13.1372 19.2917 13.5087 19.2917 13.8122 19.2669C14.1288 19.241 14.426 19.1851 14.7071 19.0419C15.1383 18.8222 15.4889 18.4716 15.7086 18.0404C15.8518 17.7593 15.9077 17.4621 15.9336 17.1456C15.9584 16.842 15.9584 16.4705 15.9583 16.0254V15.9583H16.0254C16.4705 15.9583 16.8421 15.9583 17.1456 15.9335C17.4621 15.9077 17.7594 15.8518 18.0404 15.7086C18.4716 15.4888 18.8222 15.1383 19.0419 14.7071C19.1851 14.426 19.241 14.1288 19.2669 13.8122C19.2917 13.5087 19.2917 13.1372 19.2917 12.692V7.97462C19.2917 7.5295 19.2917 7.15797 19.2669 6.85444C19.241 6.53787 19.1851 6.24066 19.0419 5.9596C18.8222 5.5284 18.4716 5.17782 18.0404 4.95811C17.7594 4.81491 17.4621 4.75898 17.1456 4.73312C16.842 4.70832 16.4705 4.70832 16.0254 4.70833ZM8.04168 11.1667V9.29167H8.00001C7.52299 9.29167 7.20281 9.29215 6.95624 9.3123C6.71697 9.33185 6.60257 9.36675 6.5271 9.4052C6.3311 9.50507 6.17175 9.66442 6.07188 9.86043C6.03343 9.93589 5.99852 10.0503 5.97898 10.2896C5.95883 10.5361 5.95834 10.8563 5.95834 11.3333V16C5.95834 16.477 5.95883 16.7972 5.97898 17.0438C5.99852 17.283 6.03343 17.3974 6.07188 17.4729C6.17175 17.6689 6.3311 17.8283 6.5271 17.9281C6.60257 17.9666 6.71697 18.0015 6.95624 18.021C7.20281 18.0412 7.52299 18.0417 8.00001 18.0417H12.6667C13.1437 18.0417 13.4639 18.0412 13.7104 18.021C13.9497 18.0015 14.0641 17.9666 14.1396 17.9281C14.3356 17.8283 14.4949 17.6689 14.5948 17.4729C14.6333 17.3974 14.6682 17.283 14.6877 17.0438C14.7079 16.7972 14.7083 16.477 14.7083 16V15.9583H12.8333C12.4882 15.9583 12.2083 15.6785 12.2083 15.3333C12.2083 14.9882 12.4882 14.7083 12.8333 14.7083H16C16.477 14.7083 16.7972 14.7078 17.0438 14.6877C17.283 14.6682 17.3974 14.6333 17.4729 14.5948C17.6689 14.4949 17.8283 14.3356 17.9281 14.1396C17.9666 14.0641 18.0015 13.9497 18.021 13.7104C18.0412 13.4639 18.0417 13.1437 18.0417 12.6667V8C18.0417 7.52298 18.0412 7.2028 18.021 6.95623C18.0015 6.71696 17.9666 6.60256 17.9281 6.52709C17.8283 6.33109 17.6689 6.17174 17.4729 6.07187C17.3974 6.03342 17.283 5.99851 17.0438 5.97896C16.7972 5.95882 16.477 5.95833 16 5.95833H11.3333C10.8563 5.95833 10.5361 5.95882 10.2896 5.97896C10.0503 5.99851 9.9359 6.03342 9.86044 6.07187C9.66444 6.17174 9.50508 6.33109 9.40521 6.52709C9.36676 6.60256 9.33186 6.71696 9.31231 6.95623C9.29216 7.2028 9.29168 7.52298 9.29168 8V11.1667C9.29168 11.5118 9.01186 11.7917 8.66668 11.7917C8.3215 11.7917 8.04168 11.5118 8.04168 11.1667Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3409_77645">
        <rect width="20" height="20" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
`;

export const CloseIcon = html`
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3409_76820)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.34314 6.34314C6.63604 6.05025 7.11091 6.05025 7.4038 6.34314L12 10.9393L16.5962 6.34314C16.8891 6.05025 17.364 6.05025 17.6569 6.34314C17.9497 6.63604 17.9497 7.11091 17.6569 7.4038L13.0607 12L17.6569 16.5962C17.9497 16.8891 17.9497 17.364 17.6569 17.6569C17.364 17.9497 16.8891 17.9497 16.5962 17.6569L12 13.0607L7.4038 17.6569C7.11091 17.9497 6.63604 17.9497 6.34314 17.6569C6.05025 17.364 6.05025 16.8891 6.34314 16.5962L10.9393 12L6.34314 7.4038C6.05025 7.11091 6.05025 6.63604 6.34314 6.34314Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3409_76820">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const MoreIcon = html`
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3407_76065)">
      <path
        d="M12 6.99999C11.5398 6.99999 11.1667 6.6269 11.1667 6.16666C11.1667 5.70642 11.5398 5.33333 12 5.33333C12.4602 5.33333 12.8333 5.70642 12.8333 6.16666C12.8333 6.6269 12.4602 6.99999 12 6.99999Z"
        fill="currentColor"
      />
      <path
        d="M12 12.8333C11.5398 12.8333 11.1667 12.4602 11.1667 12C11.1667 11.5398 11.5398 11.1667 12 11.1667C12.4602 11.1667 12.8333 11.5398 12.8333 12C12.8333 12.4602 12.4602 12.8333 12 12.8333Z"
        fill="currentColor"
      />
      <path
        d="M12 18.6667C11.5398 18.6667 11.1667 18.2936 11.1667 17.8333C11.1667 17.3731 11.5398 17 12 17C12.4602 17 12.8333 17.3731 12.8333 17.8333C12.8333 18.2936 12.4602 18.6667 12 18.6667Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 5.75001C11.7699 5.75001 11.5833 5.93655 11.5833 6.16667C11.5833 6.39679 11.7699 6.58334 12 6.58334C12.2301 6.58334 12.4167 6.39679 12.4167 6.16667C12.4167 5.93655 12.2301 5.75001 12 5.75001ZM10.75 6.16667C10.75 5.47632 11.3096 4.91667 12 4.91667C12.6904 4.91667 13.25 5.47632 13.25 6.16667C13.25 6.85703 12.6904 7.41667 12 7.41667C11.3096 7.41667 10.75 6.85703 10.75 6.16667ZM12 11.5833C11.7699 11.5833 11.5833 11.7699 11.5833 12C11.5833 12.2301 11.7699 12.4167 12 12.4167C12.2301 12.4167 12.4167 12.2301 12.4167 12C12.4167 11.7699 12.2301 11.5833 12 11.5833ZM10.75 12C10.75 11.3096 11.3096 10.75 12 10.75C12.6904 10.75 13.25 11.3096 13.25 12C13.25 12.6904 12.6904 13.25 12 13.25C11.3096 13.25 10.75 12.6904 10.75 12ZM12 17.4167C11.7699 17.4167 11.5833 17.6032 11.5833 17.8333C11.5833 18.0635 11.7699 18.25 12 18.25C12.2301 18.25 12.4167 18.0635 12.4167 17.8333C12.4167 17.6032 12.2301 17.4167 12 17.4167ZM10.75 17.8333C10.75 17.143 11.3096 16.5833 12 16.5833C12.6904 16.5833 13.25 17.143 13.25 17.8333C13.25 18.5237 12.6904 19.0833 12 19.0833C11.3096 19.0833 10.75 18.5237 10.75 17.8333Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3407_76065">
        <rect width="20" height="20" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
`;

export const LoadingBanner = html`
  <svg
    width="140"
    height="96"
    viewBox="0 0 140 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4257_88403)">
      <g opacity="0.4">
        <g clip-path="url(#clip1_4257_88403)">
          <g clip-path="url(#clip2_4257_88403)">
            <g opacity="0.8" filter="url(#filter0_f_4257_88403)">
              <ellipse
                cx="45.5713"
                cy="61.2938"
                rx="45.5713"
                ry="61.2938"
                transform="matrix(-0.275152 -0.961401 0.994111 -0.108365 23.6692 80.3025)"
                fill="#C0BFC1"
              />
            </g>
            <g opacity="0.8" filter="url(#filter1_f_4257_88403)">
              <ellipse
                cx="49.6555"
                cy="50.1114"
                rx="49.6555"
                ry="50.1114"
                transform="matrix(-0.517539 -0.855659 0.945307 -0.326182 10.3975 87.9766)"
                fill="#C0BFC1"
              />
            </g>
            <g opacity="0.8" filter="url(#filter2_f_4257_88403)">
              <path
                d="M141.154 3.03247C167.539 22.8936 134.54 99.5878 124.212 92.7915C117.912 88.6456 113.733 60.4772 94.173 45.9086C81.6691 36.5955 56.6586 38.5939 41.1056 37.1878C1.22291 33.5821 114.548 -16.9943 141.154 3.03247Z"
                fill="#C0BFC1"
              />
            </g>
            <path
              d="M78.5971 45.1263C77.9794 49.5216 81.121 53.5957 85.6131 54.2271C90.1053 54.8584 94.2481 51.808 94.8658 47.4128C95.4835 43.0175 92.342 38.9434 87.8498 38.312C83.3577 37.6807 79.2149 40.7311 78.5971 45.1263Z"
              fill="url(#paint0_linear_4257_88403)"
            />
            <path
              d="M120.378 78.3637L119.989 81.1303C119.731 82.9654 119.562 84.15 119.36 85.0413C119.166 85.8959 118.999 86.1992 118.895 86.3451C118.499 86.9002 117.932 87.3171 117.277 87.5363C117.105 87.5938 116.76 87.6677 115.867 87.6141C114.934 87.5582 113.723 87.3905 111.847 87.1268L80.6109 82.7369C78.735 82.4733 77.524 82.3006 76.6125 82.0973C75.7385 81.9024 75.4276 81.7365 75.278 81.6337C74.7087 81.2424 74.2794 80.6856 74.0516 80.0428C73.9917 79.8739 73.9142 79.5361 73.9635 78.6612C74.0149 77.7488 74.1789 76.5635 74.4369 74.7283L75.6584 66.0369C75.8058 65.9369 75.9505 65.8411 76.0924 65.7498C77.1899 65.0437 78.3629 64.4423 79.7464 64.1873C81.8083 63.8072 83.9443 64.0829 85.8427 64.9742C87.1166 65.5723 88.0991 66.452 88.9822 67.4137C89.5619 68.0451 90.1807 68.8058 90.8604 69.6691L94.5285 66.9912C95.9295 65.9684 97.1371 65.0867 98.1922 64.4415C99.3051 63.761 100.491 63.1868 101.879 62.9626C103.947 62.6286 106.075 62.9506 107.951 63.8817C109.21 64.5065 110.172 65.4058 111.033 66.385C111.033 66.385 117.277 74.3919 120.378 78.3637Z"
              fill="url(#paint1_linear_4257_88403)"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M18.0193 52.2289C18.1346 51.4086 18.8931 50.837 19.7134 50.9523L67.2463 57.6326C68.0667 57.7479 68.6382 58.5064 68.5229 59.3268C68.4076 60.1471 67.6491 60.7187 66.8288 60.6034L19.2959 53.9231C18.4755 53.8078 17.904 53.0493 18.0193 52.2289Z"
              fill="white"
              fill-opacity="0.8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M21.5681 26.9771C21.7218 25.8833 22.7332 25.1212 23.827 25.2749L47.5934 28.6151C48.6872 28.7688 49.4493 29.7801 49.2956 30.874C49.1419 31.9678 48.1305 32.7299 47.0367 32.5762L23.2703 29.236C22.1765 29.0823 21.4144 28.0709 21.5681 26.9771Z"
              fill="white"
              fill-opacity="0.8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M19.55 41.336C19.6653 40.5156 20.4238 39.9441 21.2442 40.0593L68.7771 46.7397C69.5974 46.8549 70.169 47.6135 70.0537 48.4338C69.9384 49.2542 69.1799 49.8258 68.3595 49.7105L20.8267 43.0301C20.0063 42.9149 19.4347 42.1564 19.55 41.336Z"
              fill="white"
              fill-opacity="0.8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.4883 63.1219C16.6036 62.3015 17.3621 61.7299 18.1824 61.8452L65.7153 68.5255C66.5357 68.6408 67.1072 69.3993 66.9919 70.2197C66.8766 71.0401 66.1181 71.6116 65.2978 71.4963L17.7649 64.816C16.9445 64.7007 16.373 63.9422 16.4883 63.1219Z"
              fill="white"
              fill-opacity="0.8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.2358 72.0343C15.3511 71.2139 16.1096 70.6424 16.93 70.7576L64.4628 77.438C65.2832 77.5533 65.8548 78.3118 65.7395 79.1321C65.6242 79.9525 64.8657 80.5241 64.0453 80.4088L16.5125 73.7285C15.6921 73.6132 15.1205 72.8547 15.2358 72.0343Z"
              fill="white"
              fill-opacity="0.4"
            />
          </g>
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_f_4257_88403"
        x="-14.1589"
        y="-38.4709"
        width="172.444"
        height="136.638"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="12"
          result="effect1_foregroundBlur_4257_88403"
        />
      </filter>
      <filter
        id="filter1_f_4257_88403"
        x="-45.8333"
        y="-40.3932"
        width="155.805"
        height="139.072"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="12"
          result="effect1_foregroundBlur_4257_88403"
        />
      </filter>
      <filter
        id="filter2_f_4257_88403"
        x="8.68726"
        y="-25.6425"
        width="166.468"
        height="142.859"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="12"
          result="effect1_foregroundBlur_4257_88403"
        />
      </filter>
      <linearGradient
        id="paint0_linear_4257_88403"
        x1="102.492"
        y1="40.3698"
        x2="96.2289"
        y2="84.9319"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.578125" stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4257_88403"
        x1="102.492"
        y1="40.3698"
        x2="96.2289"
        y2="84.9319"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.578125" stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <clipPath id="clip0_4257_88403">
        <rect width="140" height="96" fill="white" />
      </clipPath>
      <clipPath id="clip1_4257_88403">
        <rect
          x="11.7563"
          y="3.38196"
          width="130"
          height="88"
          rx="4"
          transform="rotate(8 11.7563 3.38196)"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip2_4257_88403">
        <rect
          width="130"
          height="88"
          fill="white"
          transform="translate(11.7563 3.38196) rotate(8)"
        />
      </clipPath>
    </defs>
  </svg>
`;

export const DarkLoadingBanner = html`
  <svg
    width="140"
    height="96"
    viewBox="0 0 140 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4391_90250)">
      <g opacity="0.4">
        <g clip-path="url(#clip1_4391_90250)">
          <g clip-path="url(#clip2_4391_90250)">
            <g opacity="0.8" filter="url(#filter0_f_4391_90250)">
              <ellipse
                cx="45.5713"
                cy="61.2938"
                rx="45.5713"
                ry="61.2938"
                transform="matrix(-0.275152 -0.961401 0.994111 -0.108365 23.6692 80.3025)"
                fill="#3E3E3F"
              />
            </g>
            <g opacity="0.8" filter="url(#filter1_f_4391_90250)">
              <ellipse
                cx="49.6555"
                cy="50.1114"
                rx="49.6555"
                ry="50.1114"
                transform="matrix(-0.517539 -0.855659 0.945307 -0.326182 10.3975 87.9766)"
                fill="#3E3E3F"
              />
            </g>
            <g opacity="0.8" filter="url(#filter2_f_4391_90250)">
              <path
                d="M141.154 3.03247C167.539 22.8936 134.54 99.5878 124.212 92.7915C117.912 88.6456 113.733 60.4772 94.173 45.9086C81.6691 36.5955 56.6586 38.5939 41.1056 37.1878C1.22291 33.5821 114.548 -16.9943 141.154 3.03247Z"
                fill="#3E3E3F"
              />
            </g>
            <path
              d="M78.5971 45.1263C77.9794 49.5216 81.121 53.5957 85.6131 54.2271C90.1053 54.8584 94.2481 51.808 94.8658 47.4128C95.4835 43.0175 92.342 38.9434 87.8498 38.312C83.3577 37.6807 79.2149 40.7311 78.5971 45.1263Z"
              fill="url(#paint0_linear_4391_90250)"
            />
            <path
              d="M120.378 78.3637L119.989 81.1303C119.731 82.9654 119.562 84.15 119.36 85.0413C119.166 85.8959 118.999 86.1992 118.895 86.3451C118.499 86.9002 117.932 87.3171 117.277 87.5363C117.105 87.5938 116.76 87.6677 115.867 87.6141C114.934 87.5582 113.723 87.3905 111.847 87.1268L80.6109 82.7369C78.735 82.4733 77.524 82.3006 76.6125 82.0973C75.7385 81.9024 75.4276 81.7365 75.278 81.6337C74.7087 81.2424 74.2794 80.6856 74.0516 80.0428C73.9917 79.8739 73.9142 79.5361 73.9635 78.6612C74.0149 77.7488 74.1789 76.5635 74.4369 74.7283L75.6584 66.0369C75.8058 65.9369 75.9505 65.8411 76.0924 65.7498C77.1899 65.0437 78.3629 64.4423 79.7464 64.1873C81.8083 63.8072 83.9443 64.0829 85.8427 64.9742C87.1166 65.5723 88.0991 66.452 88.9822 67.4137C89.5619 68.0451 90.1807 68.8058 90.8604 69.6691L94.5285 66.9912C95.9295 65.9684 97.1371 65.0867 98.1922 64.4415C99.3051 63.761 100.491 63.1868 101.879 62.9626C103.947 62.6286 106.075 62.9506 107.951 63.8817C109.21 64.5065 110.172 65.4058 111.033 66.385C111.033 66.385 117.277 74.3919 120.378 78.3637Z"
              fill="url(#paint1_linear_4391_90250)"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M18.0193 52.2289C18.1346 51.4086 18.8931 50.837 19.7134 50.9523L67.2463 57.6326C68.0667 57.7479 68.6382 58.5064 68.5229 59.3268C68.4076 60.1471 67.6491 60.7187 66.8288 60.6034L19.2959 53.9231C18.4755 53.8078 17.904 53.0493 18.0193 52.2289Z"
              fill="white"
              fill-opacity="0.8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M21.5681 26.9771C21.7218 25.8833 22.7332 25.1212 23.827 25.2749L47.5934 28.6151C48.6872 28.7688 49.4493 29.7801 49.2956 30.874C49.1419 31.9678 48.1305 32.7299 47.0367 32.5762L23.2703 29.236C22.1765 29.0823 21.4144 28.0709 21.5681 26.9771Z"
              fill="white"
              fill-opacity="0.8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M19.55 41.336C19.6653 40.5156 20.4238 39.9441 21.2442 40.0593L68.7771 46.7397C69.5974 46.8549 70.169 47.6135 70.0537 48.4338C69.9384 49.2542 69.1799 49.8258 68.3595 49.7105L20.8267 43.0301C20.0063 42.9149 19.4347 42.1564 19.55 41.336Z"
              fill="white"
              fill-opacity="0.8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.4883 63.1219C16.6036 62.3015 17.3621 61.7299 18.1824 61.8452L65.7153 68.5255C66.5357 68.6408 67.1072 69.3993 66.9919 70.2197C66.8766 71.0401 66.1181 71.6116 65.2978 71.4963L17.7649 64.816C16.9445 64.7007 16.373 63.9422 16.4883 63.1219Z"
              fill="white"
              fill-opacity="0.8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.2358 72.0344C15.3511 71.214 16.1096 70.6424 16.93 70.7577L64.4628 77.438C65.2832 77.5533 65.8548 78.3118 65.7395 79.1322C65.6242 79.9525 64.8657 80.5241 64.0453 80.4088L16.5125 73.7285C15.6921 73.6132 15.1205 72.8547 15.2358 72.0344Z"
              fill="white"
              fill-opacity="0.4"
            />
          </g>
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_f_4391_90250"
        x="-14.1589"
        y="-38.4709"
        width="172.444"
        height="136.638"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="12"
          result="effect1_foregroundBlur_4391_90250"
        />
      </filter>
      <filter
        id="filter1_f_4391_90250"
        x="-45.8333"
        y="-40.3932"
        width="155.805"
        height="139.072"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="12"
          result="effect1_foregroundBlur_4391_90250"
        />
      </filter>
      <filter
        id="filter2_f_4391_90250"
        x="8.68726"
        y="-25.6425"
        width="166.468"
        height="142.859"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="12"
          result="effect1_foregroundBlur_4391_90250"
        />
      </filter>
      <linearGradient
        id="paint0_linear_4391_90250"
        x1="102.492"
        y1="40.3698"
        x2="96.2289"
        y2="84.9319"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.578125" stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4391_90250"
        x1="102.492"
        y1="40.3698"
        x2="96.2289"
        y2="84.9319"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.578125" stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <clipPath id="clip0_4391_90250">
        <rect width="140" height="96" fill="white" />
      </clipPath>
      <clipPath id="clip1_4391_90250">
        <rect
          x="11.7563"
          y="3.38196"
          width="130"
          height="88"
          rx="4"
          transform="rotate(8 11.7563 3.38196)"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip2_4391_90250">
        <rect
          width="130"
          height="88"
          fill="white"
          transform="translate(11.7563 3.38196) rotate(8)"
        />
      </clipPath>
    </defs>
  </svg>
`;
